// @flow
import moment from 'moment'
import { message as antdMessage } from 'antd'
import { imagePath } from 'frontend_core/dist/helpers/image'

import { containerIds } from 'redux/modules/ui'
import CardHelper from 'helpers/CardHelper'

import { type PropTypes } from './index'

export function getSelectCreditCardProps(
  user: { payments: Array<*> },
  currentUser: { id: number },
  cardHelper: CardHelper,
  ui: {
    selectedCardId: number,
    isOpenCreditCard?: boolean,
    cardNumber: Array<string>,
    cardNumberErrors: Array<string>,
    cardHolderName: string,
    cardExpireMonth: string,
    cardExpireYear: string,
    cardCvc: string,
  },
  actions: {
    setUIState: Function,
    postPayment: Function,
  },
): PropTypes {
  return {
    isOpenCreditCard: ui.isOpenCreditCard,
    onClickOpenCreditCardForm: e => {
      e.preventDefault()
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        isOpenCreditCard: !ui.isOpenCreditCard,
      })
    },
    onClickAddCreditCard: e => {
      e.preventDefault()
      cardHelper.generateToken(
        {
          number: (ui.cardNumber || []).join(''),
          name: ui.cardHolderName,
          cvc: ui.cardCvc,
          exp_month: ui.cardExpireMonth,
          exp_year: ui.cardExpireYear,
        },
        {
          success: response => {
            actions.postPayment({
              userId: currentUser.id,
              paymentToken: response.id,
            })
          },
          error: response => {
            antdMessage.warning(response.error.message)
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              cardNumberErrors: [response.error.message],
            })
          },
        },
      )
    },
    radioListCard: user.payments.map(p => ({
      number: `**** **** **** ${p.last4}`,
      value: p.id,
      accountHolder: p.name,
      expirationDate: `${p.exp_month}/${p.exp_year}`,
      src: imagePath(`images/www/common/card_${p.type}.png`),
    })),
    selectedCardId: ui.selectedCardId,
    onChangePaymentCard: (cardId: number) => {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        selectedCardId: cardId,
        hasChanged: true,
      })
    },
    optionListMonth: new Array(12).fill(0).map((_, i) => ({
      label: `0${i + 1}`.slice(-2),
      value: i + 1,
    })),
    optionListYear: new Array(20).fill(0).map((_, i) => ({
      label: `${moment().year() + i}`,
      value: moment().year() + i,
    })),
    cardNumber: ui.cardNumber || [],
    cardNumberErrors: ui.cardNumberErrors,
    onChangeCardNumber: (value: string, i: number) => {
      const cardNumber = ui.cardNumber || []
      cardNumber[i] = value
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        cardNumber,
      })

      if (value.length === 4 && i < 3) {
        document.getElementById(`cardNumber${i + 1}`).focus()
      } else if (value.length === 0 && i > 0) {
        document.getElementById(`cardNumber${i - 1}`).focus()
      }
    },
    cardHolderName: ui.cardHolderName,
    onChangeCardHolderName: (value: string) => {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        cardHolderName: value,
      })
    },
    cardExpireYear: ui.cardExpireYear,
    cardExpireMonth: ui.cardExpireMonth,
    onChangeCardExpire: (type: string, value: string) => {
      switch (type) {
        case 'year':
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            cardExpireYear: value,
          })
          break
        case 'month':
          actions.setUIState(containerIds.RESERVATION_DETAIL, {
            cardExpireMonth: value,
          })
          break
      }
    },
    cvc: ui.cardCvc || '',
    onChangeCvc: (value: string) => {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        cardCvc: value,
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/SelectCreditCardSection/presenter.js